import { Component, OnInit } from '@angular/core';
import b64toBlob from 'b64-to-blob';
import { BaseRequestModel } from 'src/app/core/models/BaseModel/BaseRequestModel';
import { downloadfile } from 'src/app/core/models/UtilModel/downloadfile.model';
import { UserUtilService } from 'src/app/core/services/common/user-util.service';
import { PublicPortalService } from 'src/app/core/services/public-portal/public-portal.service';
import { saveAs } from 'file-saver';
import { GetPayRequestModel } from 'src/app/core/models/GetPayRequestModel';
import { listType } from 'src/app/core/enumerations/enum-ListType';
import { PaginationModel } from 'src/app/core/models/pagination-model';
import { Router } from '@angular/router';
import { interval } from 'rxjs';
import { map, take } from 'rxjs/operators';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  allSupplierCount: any;
  payRequestModel: GetPayRequestModel;
  paginationModel: PaginationModel;
  NonConsultingServicesCount: any;
  GoodsCount: any;
  WorksCount: any;
  ConsultingServicesCount: any;
  AllCount: any;
  PortalNewsAndAnnouncements: any;
  downloadFile: downloadfile;
  byteImage: any
  FileGUID: any;
  AttachmentId: any;
  currentDate = new Date()
  byteImage1: string;
  listByteImage: any[];
  arrayList: any[] = [];
  UrlLink: any;
  totalPages: number;
  totalRecords: any;
  pages: any[];
  Records: any;
  tenderCount: any;
  Description: any;
  Title: any;
  IsPublishToPortal: boolean = false;
  SectionType: number;
  arrayListSection1: any[] = [];
  arrayListSection2: any[] = [];
  arrayListSection3: any[] = [];
  arrayListSection4: any[] = [];
  arrayListSection5: any[] = [];
  arrayListSection6: any[] = [];
  arrayListSection6_1: any[] = [];
  arrayListSection7: any[] = [];
  arrayListSection7_1: any[] = [];
  arrayListSection7_2: any[] = [];
  arrayListSection7_3: any[] = [];
  arrayListSection8: any[] = [];
  arrayListSection8_1: any[] = [];
  arrayListSection8_2: any[] = [];
  arrayListSection9: any[] = [];
  arrayListSection10: any[] = [];
  Section1Array: any;
  Section3Array: any;
  Section4Array: any;
  Section2Array: any;
  Section5Array: any;
  Section6Array: any;
  Section6_1Array: any;
  Section7Array: any;
  Section7_1Array: any;
  Section7_2Array: any;
  Section7_3Array: any;
  Section8Array: any;
  Section8_1Array: any;
  Section8_2Array: any;
  Section9Array: any;
  Section10Array: any;
  DescriptionDetail: any;
  Priority: any;
  IsPublishToPortalSection1: boolean = false;
  IsPublishToPortalSection2: boolean = false;
  IsPublishToPortalSection3: boolean = false;
  IsPublishToPortalSection4: boolean = false;
  IsPublishToPortalSection5: boolean = false;
  IsPublishToPortalSection6: boolean = false;
  IsPublishToPortalSection6_1: boolean = false;
  IsPublishToPortalSection7: boolean = false;
  IsPublishToPortalSection7_1: boolean = false;
  IsPublishToPortalSection7_2: boolean = false;
  IsPublishToPortalSection7_3: boolean = false;
  IsPublishToPortalSection8: boolean = false;
  IsPublishToPortalSection8_1: boolean = false;
  IsPublishToPortalSection8_2: boolean = false;
  IsPublishToPortalSection9: boolean = false;
  IsPublishToPortalSection10: boolean = false;
  fixedItems = [
    { title: 'AJ&K  PPRA', link: 'https://www.ajkppra.gov.pk/' },
    { title: 'Balochistan  PPRA', link: 'https://bppthree.vdc.services/' },
    { title: 'GB  PPRA', link: 'https://www.gbppra.gov.pk/' },
    { title: 'KP  PPRA', link: 'https://kppra.gov.pk/' },
    { title: 'Punjab  PRA', link: 'https://ppra.punjab.gov.pk/' },
    { title: 'Sindh  PPRA', link: 'http://www.pprasindh.gov.pk/' }
  ];

  allHighlights: any[] = [];
  dashboardDataModel: any;
  constructor(public userUtilsService: UserUtilService,
    public portalService: PublicPortalService, public route: Router) { }
  animatedCounts: { [key: string]: number } = {};


  ngOnInit(): void {
    this.listByteImage = []
    this.arrayList = []
    this.downloadFile = new downloadfile();
    this.paginationModel = new PaginationModel();
    this.payRequestModel = new GetPayRequestModel();
    this.GetPortalNewsAndAnnouncements()
    this.GetPayDetailList()
    this.getSuppliersDashboardCount()
    this.getDashboardData()
    this.getTenderData()
    this.downloadFile = new downloadfile()
    this.getAllHighlights()

  }

  // startCountingAnimation(property: string) {
  //   const endValue = this.dashboardDataModel?.[property] || 0;
  //   const duration = 2000; // 2 seconds
  //   const steps = 50; // Number of animation steps
  //   const intervalTime = duration / steps;

  //   if (endValue > 0) {
  //     interval(intervalTime)
  //       .pipe(
  //         take(steps),
  //         map((step) => Math.round((step / steps) * endValue))
  //       )
  //       .subscribe((value) => {
  //         this.animatedCounts[property] = value;
  //       });
  //   } else {
  //     this.animatedCounts[property] = 0;
  //   }
  // }


  getAllHighlights() {
    this.portalService.getAllHighLights()
      .subscribe(baseResponse => {
        if (baseResponse != null) {
          if (baseResponse.success != null) {
            if (baseResponse.success) {
              this.allHighlights = baseResponse?.data

            }
          }

        }

      })
  }
  GetPayDetailList() {
    debugger
    this.payRequestModel.Type = listType.TendersCount;
    this.payRequestModel.ID = 0;
    this.payRequestModel.pagination = this.paginationModel;
    this.payRequestModel.pagination.pageSize = "10"
    this.portalService.GetPayDetailListTenderEIOPQ(this.payRequestModel)
      .subscribe(baseResponse => {
        if (baseResponse != null) {
          if (baseResponse.success != null) {
            if (baseResponse.success) {
              let data = (baseResponse.data as any);
              this.totalPages = data?.totalPages;
              this.totalRecords = data?.totalRecords;
              this.pages = new Array();
              for (let i = 1; i <= this.totalPages; i++) {
                this.pages.push(i);
              }
              this.Records = data?.records;
            }
          }
        }
      })
  }
  getSuppliersDashboardCount() {
    this.portalService.GetPPRRASupplierCount()
      .subscribe(baseResponse => {
        if (baseResponse != null) {
          if (baseResponse.success != null) {
            if (baseResponse.success) {
              this.allSupplierCount = baseResponse?.data
              this.AllCount = this.allSupplierCount[0].AllCount
              this.NonConsultingServicesCount = this.allSupplierCount[0].NonConsultingServicesCount
              this.GoodsCount = this.allSupplierCount[0].GoodsCount
              this.WorksCount = this.allSupplierCount[0].WorksCount
              this.ConsultingServicesCount = this.allSupplierCount[0].ConsultingServicesCount
            }
          }

        }

      })
  }
  GetPortalNewsAndAnnouncements() {
    this.portalService.GetPortalNewsAndAnnouncements()
      .subscribe(baseResponse => {
        if (baseResponse != null) {
          if (baseResponse.success != null) {
            if (baseResponse.success) {

              this.PortalNewsAndAnnouncements = baseResponse?.data
              if (this.PortalNewsAndAnnouncements != null) {

                this.Section1Array = this.PortalNewsAndAnnouncements.filter(item => item.SectionType === 33);
                this.Section2Array = this.PortalNewsAndAnnouncements.filter(item => item.SectionType === 2);
                this.Section3Array = this.PortalNewsAndAnnouncements.filter(item => item.SectionType === 3);
                this.Section4Array = this.PortalNewsAndAnnouncements.filter(item => item.SectionType === 4);
                this.Section5Array = this.PortalNewsAndAnnouncements.filter(item => item.SectionType === 5);
                this.Section6Array = this.PortalNewsAndAnnouncements.filter(item => item.SectionType === 6);
                this.Section6_1Array = this.PortalNewsAndAnnouncements.filter(item => item.SectionType === 18);
                this.Section7Array = this.PortalNewsAndAnnouncements.filter(item => item.SectionType === 7);
                this.Section7_1Array = this.PortalNewsAndAnnouncements.filter(item => item.SectionType === 13);
                this.Section7_2Array = this.PortalNewsAndAnnouncements.filter(item => item.SectionType === 14);
                this.Section7_3Array = this.PortalNewsAndAnnouncements.filter(item => item.SectionType === 15);
                this.Section8Array = this.PortalNewsAndAnnouncements.filter(item => item.SectionType === 8);
                this.Section8_1Array = this.PortalNewsAndAnnouncements.filter(item => item.SectionType === 16);
                this.Section8_2Array = this.PortalNewsAndAnnouncements.filter(item => item.SectionType === 17);
                this.Section9Array = this.PortalNewsAndAnnouncements.filter(item => item.SectionType === 11);
                this.Section10Array = this.PortalNewsAndAnnouncements.filter(item => item.SectionType === 12);
                for (let i = 0; i < this.Section1Array.length; i++) {
                  this.FileGUID = this.Section1Array[i].FileGuid;
                  this.AttachmentId = this.Section1Array[i].AttachmentId;
                  this.UrlLink = this.Section1Array[i].UrlLink;
                  this.Title = this.Section1Array[i].Title;
                  this.Description = this.Section1Array[i].Description;
                  this.IsPublishToPortalSection1 = this.Section1Array[i].IsPublishToPortal;
                  this.SectionType = this.Section1Array[i].SectionType;
                  this.DescriptionDetail = this.Section1Array[i].DescriptionDetail;
                  this.getAttachmentByIDSection1(i, this.AttachmentId, this.FileGUID, this.UrlLink, this.Title, this.Description, this.SectionType, this.DescriptionDetail)
                }
                for (let i = 0; i < this.Section2Array.length; i++) {
                  this.FileGUID = this.Section2Array[i].FileGuid;
                  this.AttachmentId = this.Section2Array[i].AttachmentId;
                  this.UrlLink = this.Section2Array[i].UrlLink;
                  this.Title = this.Section2Array[i].Title;
                  this.Description = this.Section2Array[i].Description;
                  this.IsPublishToPortalSection2 = this.Section2Array[i].IsPublishToPortal;
                  this.SectionType = this.Section2Array[i].SectionType;
                  this.DescriptionDetail = this.Section2Array[i].DescriptionDetail;
                  this.getAttachmentByIDSection2(i, this.AttachmentId, this.FileGUID, this.UrlLink, this.Title, this.Description, this.SectionType, this.DescriptionDetail)
                }
                for (let i = 0; i < this.Section3Array.length; i++) {
                  this.FileGUID = this.Section3Array[i].FileGuid;
                  this.AttachmentId = this.Section3Array[i].AttachmentId;
                  this.UrlLink = this.Section3Array[i].UrlLink;
                  this.Title = this.Section3Array[i].Title;
                  this.Description = this.Section3Array[i].Description;
                  this.IsPublishToPortalSection3 = this.Section3Array[i].IsPublishToPortal;
                  this.SectionType = this.Section3Array[i].SectionType;
                  this.DescriptionDetail = this.Section3Array[i].DescriptionDetail;
                  this.Priority = this.Section3Array[i].Priority;
                  this.getAttachmentByIDSection3(i, this.AttachmentId, this.FileGUID, this.UrlLink, this.Title, this.Description, this.SectionType, this.DescriptionDetail, this.Priority)
                }
                for (let i = 0; i < this.Section4Array.length; i++) {
                  this.FileGUID = this.Section4Array[i].FileGuid;
                  this.AttachmentId = this.Section4Array[i].AttachmentId;
                  this.UrlLink = this.Section4Array[i].UrlLink;
                  this.Title = this.Section4Array[i].Title;
                  this.Description = this.Section4Array[i].Description;
                  this.IsPublishToPortalSection4 = this.Section4Array[i].IsPublishToPortal;
                  this.SectionType = this.Section4Array[i].SectionType;
                  this.DescriptionDetail = this.Section4Array[i].DescriptionDetail;
                  this.Priority = this.Section4Array[i].Priority;
                  this.getAttachmentByIDSection4(i, this.AttachmentId, this.FileGUID, this.UrlLink, this.Title, this.Description, this.SectionType, this.DescriptionDetail, this.Priority)
                }
                for (let i = 0; i < this.Section5Array.length; i++) {
                  this.FileGUID = this.Section5Array[i].FileGuid;
                  this.AttachmentId = this.Section5Array[i].AttachmentId;
                  this.UrlLink = this.Section5Array[i].UrlLink;
                  this.Title = this.Section5Array[i].Title;
                  this.Description = this.Section5Array[i].Description;
                  this.IsPublishToPortalSection5 = this.Section5Array[i].IsPublishToPortal;
                  this.SectionType = this.Section5Array[i].SectionType;
                  this.DescriptionDetail = this.Section5Array[i].DescriptionDetail;
                  this.getAttachmentByIDSection5(i, this.AttachmentId, this.FileGUID, this.UrlLink, this.Title, this.Description, this.SectionType, this.DescriptionDetail)
                }
                for (let i = 0; i < this.Section6Array.length; i++) {
                  this.FileGUID = this.Section6Array[i].FileGuid;
                  this.AttachmentId = this.Section6Array[i].AttachmentId;
                  this.UrlLink = this.Section6Array[i].UrlLink;
                  this.Title = this.Section6Array[i].Title;
                  this.Description = this.Section6Array[i].Description;
                  this.IsPublishToPortalSection6 = this.Section6Array[i].IsPublishToPortal;
                  this.SectionType = this.Section6Array[i].SectionType;
                  this.DescriptionDetail = this.Section6Array[i].DescriptionDetail;
                  this.getAttachmentByIDSection6(i, this.AttachmentId, this.FileGUID, this.UrlLink, this.Title, this.Description, this.SectionType, this.DescriptionDetail)
                }
                for (let i = 0; i < this.Section6_1Array.length; i++) {
                  this.FileGUID = this.Section6_1Array[i].FileGuid;
                  this.AttachmentId = this.Section6_1Array[i].AttachmentId;
                  this.UrlLink = this.Section6_1Array[i].UrlLink;
                  this.Title = this.Section6_1Array[i].Title;
                  this.Description = this.Section6_1Array[i].Description;
                  this.IsPublishToPortalSection6_1 = this.Section6_1Array[i].IsPublishToPortal;
                  this.SectionType = this.Section6_1Array[i].SectionType;
                  this.DescriptionDetail = this.Section6_1Array[i].DescriptionDetail;
                  this.getAttachmentByIDSection6_1(i, this.AttachmentId, this.FileGUID, this.UrlLink, this.Title, this.Description, this.SectionType, this.DescriptionDetail)
                }
                for (let i = 0; i < this.Section7Array.length; i++) {
                  this.FileGUID = this.Section7Array[i].FileGuid;
                  this.AttachmentId = this.Section7Array[i].AttachmentId;
                  this.UrlLink = this.Section7Array[i].UrlLink;
                  this.Title = this.Section7Array[i].Title;
                  this.Description = this.Section7Array[i].Description;
                  this.IsPublishToPortalSection7 = this.Section7Array[i].IsPublishToPortal;
                  this.SectionType = this.Section7Array[i].SectionType;
                  this.DescriptionDetail = this.Section7Array[i].DescriptionDetail;
                  this.getAttachmentByIDSection7(i, this.AttachmentId, this.FileGUID, this.UrlLink, this.Title, this.Description, this.SectionType, this.DescriptionDetail)
                }
                for (let i = 0; i < this.Section7_1Array.length; i++) {
                  this.FileGUID = this.Section7_1Array[i].FileGuid;
                  this.AttachmentId = this.Section7_1Array[i].AttachmentId;
                  this.UrlLink = this.Section7_1Array[i].UrlLink;
                  this.Title = this.Section7_1Array[i].Title;
                  this.Description = this.Section7_1Array[i].Description;
                  this.IsPublishToPortalSection7_1 = this.Section7_1Array[i].IsPublishToPortal;
                  this.SectionType = this.Section7_1Array[i].SectionType;
                  this.DescriptionDetail = this.Section7_1Array[i].DescriptionDetail;
                  this.getAttachmentByIDSection7_1(i, this.AttachmentId, this.FileGUID, this.UrlLink, this.Title, this.Description, this.SectionType, this.DescriptionDetail)
                }
                for (let i = 0; i < this.Section7_2Array.length; i++) {
                  this.FileGUID = this.Section7_2Array[i].FileGuid;
                  this.AttachmentId = this.Section7_2Array[i].AttachmentId;
                  this.UrlLink = this.Section7_2Array[i].UrlLink;
                  this.Title = this.Section7_2Array[i].Title;
                  this.Description = this.Section7_2Array[i].Description;
                  this.IsPublishToPortalSection7_2 = this.Section7_2Array[i].IsPublishToPortal;
                  this.SectionType = this.Section7_2Array[i].SectionType;
                  this.DescriptionDetail = this.Section7_2Array[i].DescriptionDetail;
                  this.getAttachmentByIDSection7_2(i, this.AttachmentId, this.FileGUID, this.UrlLink, this.Title, this.Description, this.SectionType, this.DescriptionDetail)
                }
                for (let i = 0; i < this.Section7_3Array.length; i++) {
                  this.FileGUID = this.Section7_3Array[i].FileGuid;
                  this.AttachmentId = this.Section7_3Array[i].AttachmentId;
                  this.UrlLink = this.Section7_3Array[i].UrlLink;
                  this.Title = this.Section7_3Array[i].Title;
                  this.Description = this.Section7_3Array[i].Description;
                  this.IsPublishToPortalSection7_3 = this.Section7_3Array[i].IsPublishToPortal;
                  this.SectionType = this.Section7_3Array[i].SectionType;
                  this.DescriptionDetail = this.Section7_3Array[i].DescriptionDetail;
                  this.getAttachmentByIDSection7_3(i, this.AttachmentId, this.FileGUID, this.UrlLink, this.Title, this.Description, this.SectionType, this.DescriptionDetail)
                }
                for (let i = 0; i < this.Section8Array.length; i++) {
                  this.FileGUID = this.Section8Array[i].FileGuid;
                  this.AttachmentId = this.Section8Array[i].AttachmentId;
                  this.UrlLink = this.Section8Array[i].UrlLink;
                  this.Title = this.Section8Array[i].Title;
                  this.Description = this.Section8Array[i].Description;
                  this.IsPublishToPortalSection8 = this.Section8Array[i].IsPublishToPortal;
                  this.SectionType = this.Section8Array[i].SectionType;
                  this.DescriptionDetail = this.Section8Array[i].DescriptionDetail;
                  this.getAttachmentByIDSection8(i, this.AttachmentId, this.FileGUID, this.UrlLink, this.Title, this.Description, this.SectionType, this.DescriptionDetail)
                }
                for (let i = 0; i < this.Section8_1Array.length; i++) {
                  this.FileGUID = this.Section8_1Array[i].FileGuid;
                  this.AttachmentId = this.Section8_1Array[i].AttachmentId;
                  this.UrlLink = this.Section8_1Array[i].UrlLink;
                  this.Title = this.Section8_1Array[i].Title;
                  this.Description = this.Section8_1Array[i].Description;
                  this.IsPublishToPortalSection8_1 = this.Section8_1Array[i].IsPublishToPortal;
                  this.SectionType = this.Section8_1Array[i].SectionType;
                  this.DescriptionDetail = this.Section8_1Array[i].DescriptionDetail;
                  this.getAttachmentByIDSection8_1(i, this.AttachmentId, this.FileGUID, this.UrlLink, this.Title, this.Description, this.SectionType, this.DescriptionDetail)
                }
                for (let i = 0; i < this.Section8_2Array.length; i++) {
                  this.FileGUID = this.Section8_2Array[i].FileGuid;
                  this.AttachmentId = this.Section8_2Array[i].AttachmentId;
                  this.UrlLink = this.Section8_2Array[i].UrlLink;
                  this.Title = this.Section8_2Array[i].Title;
                  this.Description = this.Section8_2Array[i].Description;
                  this.IsPublishToPortalSection8_2 = this.Section8_2Array[i].IsPublishToPortal;
                  this.SectionType = this.Section8_2Array[i].SectionType;
                  this.DescriptionDetail = this.Section8_2Array[i].DescriptionDetail;
                  this.getAttachmentByIDSection8_2(i, this.AttachmentId, this.FileGUID, this.UrlLink, this.Title, this.Description, this.SectionType, this.DescriptionDetail)
                }
                for (let i = 0; i < this.Section9Array.length; i++) {
                  this.FileGUID = this.Section9Array[i].FileGuid;
                  this.AttachmentId = this.Section9Array[i].AttachmentId;
                  this.UrlLink = this.Section9Array[i].UrlLink;
                  this.Title = this.Section9Array[i].Title;
                  this.Description = this.Section9Array[i].Description;
                  this.IsPublishToPortalSection9 = this.Section9Array[i].IsPublishToPortal;
                  this.SectionType = this.Section9Array[i].SectionType;
                  this.DescriptionDetail = this.Section9Array[i].DescriptionDetail;
                  this.getAttachmentByIDSection9(i, this.AttachmentId, this.FileGUID, this.UrlLink, this.Title, this.Description, this.SectionType, this.DescriptionDetail)
                }
                for (let i = 0; i < this.Section10Array.length; i++) {
                  this.FileGUID = this.Section10Array[i].FileGuid;
                  this.AttachmentId = this.Section10Array[i].AttachmentId;
                  this.UrlLink = this.Section10Array[i].UrlLink;
                  this.Title = this.Section10Array[i].Title;
                  this.Description = this.Section10Array[i].Description;
                  this.IsPublishToPortalSection10 = this.Section10Array[i].IsPublishToPortal;
                  this.SectionType = this.Section10Array[i].SectionType;
                  this.DescriptionDetail = this.Section10Array[i].DescriptionDetail;
                  this.getAttachmentByIDSection10(i, this.AttachmentId, this.FileGUID, this.UrlLink, this.Title, this.Description, this.SectionType, this.DescriptionDetail)
                }

              }
            }
          }
        }
      })
  }
  getAttachmentByIDSection1(i, Id: any, Guid: any, Url: any, title: any, description: any, SectionType: any, DescriptionDetail: any) {

    if (Id == 0 || Id == null) {

      Id = 0
      Guid = ''
      this.arrayListSection1.push({ Url, title, description, SectionType, DescriptionDetail });
    }

    this.downloadFile.ID = Id;
    this.downloadFile.idsList = Guid;
    this.portalService.DownloadFileByGuid(this.downloadFile).subscribe(baseResponse => {
      if (baseResponse.success && baseResponse.data != null) {

        var Bytes = ''
        Bytes = baseResponse.data['bytes'];
        var BytesData = "data:image/png;base64," + Bytes;
        this.arrayListSection1.push({ Url, BytesData, title, description, SectionType, DescriptionDetail });
      }
    });
  }
  getAttachmentByIDSection2(i, Id: any, Guid: any, Url: any, title: any, description: any, SectionType: any, DescriptionDetail: any) {
    if (Id == 0 || Id == null) {
      Id = 0
      Guid = ''
      this.arrayListSection2.push({ Url, title, description, SectionType, DescriptionDetail });
    }
    this.downloadFile.ID = Id;
    this.downloadFile.idsList = Guid;
    this.portalService.DownloadFileByGuid(this.downloadFile).subscribe(baseResponse => {
      if (baseResponse.success && baseResponse.data != null) {
        var Bytes = ''
        Bytes = baseResponse.data['bytes'];
        var BytesData = "data:image/png;base64," + Bytes;
        this.arrayListSection2.push({ Url, BytesData, title, description, SectionType, DescriptionDetail });
      }
    });
  }
  getAttachmentByIDSection3(i, Id: any, Guid: any, Url: any, title: any, description: any, SectionType: any, DescriptionDetail: any, Priority: any) {
    if (Id == 0 || Id == null) {
      Id = 0;
      Guid = '';
      let newItem = { Url, title, description, SectionType, DescriptionDetail, Priority: Priority || 0 };
      this.arrayListSection3.unshift(newItem); // Push based on priority
    }

    // console.log("Priority:", Priority); // Debugging Priority

    this.downloadFile.ID = Id;
    this.downloadFile.idsList = Guid;

    this.portalService.DownloadFileByGuid(this.downloadFile).subscribe(baseResponse => {
      if (baseResponse.success && baseResponse.data != null) {
        var Bytes = baseResponse.data['bytes'];
        var BytesData = "data:image/png;base64," + Bytes;

        let newItem = { Url, BytesData, title, description, SectionType, DescriptionDetail, Priority: Priority || 1 };
        this.arrayListSection3.push(newItem); // Add item

        // Sort array so highest priority items appear first
        this.arrayListSection3.sort((a, b) => a.Priority - b.Priority);
        // console.log(this.arrayListSection3);
      }
    });
  }
  getAttachmentByIDSection4(i, Id: any, Guid: any, Url: any, title: any, description: any, SectionType: any, DescriptionDetail: any, Priority: any) {
    // logic change for sorting the elements on bases of priority base
    if (Id == 0 || Id == null) {
      if (Id == 0 || Id == null) {
        Id = 0
        Guid = ''
        let newItem = { Url, title, description, SectionType, DescriptionDetail, Priority: Priority || 0 };

        // this.arrayListSection4.push({ Url, title, description, SectionType, DescriptionDetail, Priority });
        this.arrayListSection4.unshift(newItem); // Push based on priority

      }
    }
    else {
      this.downloadFile.ID = Id;
      this.downloadFile.idsList = Guid;
      this.portalService.DownloadFileByGuid(this.downloadFile).subscribe(baseResponse => {
        if (baseResponse.success && baseResponse.data != null) {
          var Bytes = ''
          Bytes = baseResponse.data['bytes'];
          var BytesData = "data:image/png;base64," + Bytes;
          let newItem = { Url, BytesData, title, description, SectionType, DescriptionDetail, Priority: Priority || 1 };
          this.arrayListSection4.push(newItem);

          this.arrayListSection4.sort((a, b) => a.Priority - b.Priority);
        }
      });

      console.log(this.arrayListSection4);
    }
  }
  getAttachmentByIDSection5(i, Id: any, Guid: any, Url: any, title: any, description: any, SectionType: any, DescriptionDetail: any) {
    if (Id == 0 || Id == null) {
      Id = 0
      Guid = ''
      this.arrayListSection5.push({ Url, title, description, SectionType, DescriptionDetail });
    }
    this.downloadFile.ID = Id;
    this.downloadFile.idsList = Guid;
    this.portalService.DownloadFileByGuid(this.downloadFile).subscribe(baseResponse => {
      if (baseResponse.success && baseResponse.data != null) {
        var Bytes = ''
        Bytes = baseResponse.data['bytes'];
        var BytesData = "data:image/png;base64," + Bytes;
        this.arrayListSection5.push({ Url, BytesData, title, description, SectionType, DescriptionDetail });
      }
    });
  }
  getAttachmentByIDSection6(i, Id: any, Guid: any, Url: any, title: any, description: any, SectionType: any, DescriptionDetail: any) {
    if (Id == 0 || Id == null) {
      Id = 0
      Guid = ''
      this.arrayListSection6.push({ Url, title, description, SectionType, DescriptionDetail });
    }
    this.downloadFile.ID = Id;
    this.downloadFile.idsList = Guid;
    this.portalService.DownloadFileByGuid(this.downloadFile).subscribe(baseResponse => {
      if (baseResponse.success && baseResponse.data != null) {
        var Bytes = ''
        Bytes = baseResponse.data['bytes'];
        var BytesData = "data:image/png;base64," + Bytes;
        this.arrayListSection6.push({ Url, BytesData, title, description, SectionType, DescriptionDetail });
      }
    });
  }
  getAttachmentByIDSection6_1(i, Id: any, Guid: any, Url: any, title: any, description: any, SectionType: any, DescriptionDetail: any) {
    if (Id == 0 || Id == null) {
      Id = 0
      Guid = ''
      this.arrayListSection6_1.push({ Url, title, description, SectionType, DescriptionDetail });
    }
    this.downloadFile.ID = Id;
    this.downloadFile.idsList = Guid;
    this.portalService.DownloadFileByGuid(this.downloadFile).subscribe(baseResponse => {
      if (baseResponse.success && baseResponse.data != null) {
        var Bytes = ''
        Bytes = baseResponse.data['bytes'];
        var BytesData = "data:image/png;base64," + Bytes;
        this.arrayListSection6_1.push({ Url, BytesData, title, description, SectionType, DescriptionDetail });
      }
    });
  }
  getAttachmentByIDSection7(i, Id: any, Guid: any, Url: any, title: any, description: any, SectionType: any, DescriptionDetail: any) {
    if (Id == 0 || Id == null) {
      Id = 0
      Guid = ''
      this.arrayListSection7.push({ Url, title, description, SectionType, DescriptionDetail });
    }
    this.downloadFile.ID = Id;
    this.downloadFile.idsList = Guid;
    this.portalService.DownloadFileByGuid(this.downloadFile).subscribe(baseResponse => {
      if (baseResponse.success && baseResponse.data != null) {
        var Bytes = ''
        Bytes = baseResponse.data['bytes'];
        var BytesData = "data:image/png;base64," + Bytes;
        this.arrayListSection7.push({ Url, BytesData, title, description, SectionType, DescriptionDetail });
      }
    });
  }
  getAttachmentByIDSection7_1(i, Id: any, Guid: any, Url: any, title: any, description: any, SectionType: any, DescriptionDetail: any) {
    if (Id == 0 || Id == null) {
      Id = 0
      Guid = ''
      this.arrayListSection7_1.push({ Url, title, description, SectionType, DescriptionDetail });
    }
    this.downloadFile.ID = Id;
    this.downloadFile.idsList = Guid;
    this.portalService.DownloadFileByGuid(this.downloadFile).subscribe(baseResponse => {
      if (baseResponse.success && baseResponse.data != null) {
        var Bytes = ''
        Bytes = baseResponse.data['bytes'];
        var BytesData = "data:image/png;base64," + Bytes;
        this.arrayListSection7_1.push({ Url, BytesData, title, description, SectionType, DescriptionDetail });
      }
    });
  }
  getAttachmentByIDSection7_2(i, Id: any, Guid: any, Url: any, title: any, description: any, SectionType: any, DescriptionDetail: any) {
    if (Id == 0 || Id == null) {
      Id = 0
      Guid = ''
      this.arrayListSection7_2.push({ Url, title, description, SectionType, DescriptionDetail });
    }
    this.downloadFile.ID = Id;
    this.downloadFile.idsList = Guid;
    this.portalService.DownloadFileByGuid(this.downloadFile).subscribe(baseResponse => {
      if (baseResponse.success && baseResponse.data != null) {
        var Bytes = ''
        Bytes = baseResponse.data['bytes'];
        var BytesData = "data:image/png;base64," + Bytes;
        this.arrayListSection7_2.push({ Url, BytesData, title, description, SectionType, DescriptionDetail });
      }
    });
  }
  getAttachmentByIDSection7_3(i, Id: any, Guid: any, Url: any, title: any, description: any, SectionType: any, DescriptionDetail: any) {
    if (Id == 0 || Id == null) {
      Id = 0
      Guid = ''
      this.arrayListSection7_3.push({ Url, title, description, SectionType, DescriptionDetail });
    }
    this.downloadFile.ID = Id;
    this.downloadFile.idsList = Guid;
    this.portalService.DownloadFileByGuid(this.downloadFile).subscribe(baseResponse => {
      if (baseResponse.success && baseResponse.data != null) {
        var Bytes = ''
        Bytes = baseResponse.data['bytes'];
        var BytesData = "data:image/png;base64," + Bytes;
        this.arrayListSection7_3.push({ Url, BytesData, title, description, SectionType, DescriptionDetail });
      }
    });
  }
  getAttachmentByIDSection8(i, Id: any, Guid: any, Url: any, title: any, description: any, SectionType: any, DescriptionDetail: any) {
    if (Id == 0 || Id == null) {
      Id = 0
      Guid = ''
      this.arrayListSection8.push({ Url, title, description, SectionType, DescriptionDetail });
    }
    this.downloadFile.ID = Id;
    this.downloadFile.idsList = Guid;
    this.portalService.DownloadFileByGuid(this.downloadFile).subscribe(baseResponse => {
      if (baseResponse.success && baseResponse.data != null) {
        var Bytes = ''
        Bytes = baseResponse.data['bytes'];
        var BytesData = "data:image/png;base64," + Bytes;
        this.arrayListSection8.push({ Url, BytesData, title, description, SectionType, DescriptionDetail });
      }
    });
  }
  getAttachmentByIDSection8_1(i, Id: any, Guid: any, Url: any, title: any, description: any, SectionType: any, DescriptionDetail: any) {
    if (Id == 0 || Id == null) {
      Id = 0
      Guid = ''
      this.arrayListSection8_1.push({ Url, title, description, SectionType, DescriptionDetail });
    }
    this.downloadFile.ID = Id;
    this.downloadFile.idsList = Guid;
    this.portalService.DownloadFileByGuid(this.downloadFile).subscribe(baseResponse => {
      if (baseResponse.success && baseResponse.data != null) {
        var Bytes = ''
        Bytes = baseResponse.data['bytes'];
        var BytesData = "data:image/png;base64," + Bytes;
      }
    });
  }
  getAttachmentByIDSection8_2(i, Id: any, Guid: any, Url: any, title: any, description: any, SectionType: any, DescriptionDetail: any) {
    if (Id == 0 || Id == null) {
      Id = 0
      Guid = ''
      this.arrayListSection8_2.push({ Url, title, description, SectionType, DescriptionDetail });
    }
    this.downloadFile.ID = Id;
    this.downloadFile.idsList = Guid;
    this.portalService.DownloadFileByGuid(this.downloadFile).subscribe(baseResponse => {
      if (baseResponse.success && baseResponse.data != null) {
        var Bytes = ''
        Bytes = baseResponse.data['bytes'];
        var BytesData = "data:image/png;base64," + Bytes;
        this.arrayListSection8_2.push({ Url, BytesData, title, description, SectionType, DescriptionDetail });
      }
    });
  }
  getAttachmentByIDSection9(i, Id: any, Guid: any, Url: any, title: any, description: any, SectionType: any, DescriptionDetail: any) {
    if (Id == 0 || Id == null) {
      Id = 0
      Guid = ''
      this.arrayListSection9.push({ Url, title, description, SectionType, DescriptionDetail });
    }
    this.downloadFile.ID = Id;
    this.downloadFile.idsList = Guid;
    this.portalService.DownloadFileByGuid(this.downloadFile).subscribe(baseResponse => {
      if (baseResponse.success && baseResponse.data != null) {
        var Bytes = ''
        Bytes = baseResponse.data['bytes'];
        var BytesData = "data:image/png;base64," + Bytes;
        this.arrayListSection9.push({ Url, BytesData, title, description, SectionType, DescriptionDetail });
      }
    });
  }
  getAttachmentByIDSection10(i, Id: any, Guid: any, Url: any, title: any, description: any, SectionType: any, DescriptionDetail: any) {
    if (Id == 0 || Id == null) {
      Id = 0
      Guid = ''
      this.arrayListSection10.push({ Url, title, description, SectionType, DescriptionDetail });
    }
    this.downloadFile.ID = Id;
    this.downloadFile.idsList = Guid;
    this.portalService.DownloadFileByGuid(this.downloadFile).subscribe(baseResponse => {
      if (baseResponse.success && baseResponse.data != null) {
        var Bytes = ''
        Bytes = baseResponse.data['bytes'];
        var BytesData = "data:image/png;base64," + Bytes;
        this.arrayListSection10.push({ Url, BytesData, title, description, SectionType, DescriptionDetail });
      }
    });
  }

  getClassForUrl(url: string): string {
    switch (url) {
      case 'https://portal.eprocure.gov.pk/#/other/procurement-plan':
        return 'green';
      case 'https://portal.eprocure.gov.pk/#/tenders':
        return 'blue';
      case 'https://portal.eprocure.gov.pk/#/other/evaluation-results':
        return 'yellow';
      case 'https://portal.eprocure.gov.pk/#/other/procurement-contracts':
        return 'gray';
      case 'https://portal.eprocure.gov.pk/#/other/register-suppliers':
        return 'green';
      case 'https://portal.eprocure.gov.pk/#/other/pepra-active-black-listed-firms':
        return 'yellow';
      case 'https://portal.eprocure.gov.pk/#/other/FAQ':
        return 'blue';
      case 'https://portal.eprocure.gov.pk/#/documents/regulations':
        return 'yellow';
      case 'https://portal.eprocure.gov.pk/#/documents/pp-rules':
        return 'green';
      case 'https://portal.eprocure.gov.pk/#/other/downloads':
        return 'green';
      default:
        return '';
    }
  }

  getAttachmentByID(Id: any, Guid: any) {
    if (Id == 0 || Id == null) {
      return;
    }
    this.downloadFile.ID = Id;
    this.downloadFile.idsList = Guid;

    this.portalService.DownloadFileByGuid(this.downloadFile).subscribe(baseResponse => {
      if (baseResponse.success && baseResponse.data != null) {
        var Bytes = baseResponse.data['bytes'];
        var ContentType = baseResponse.data['contentType'];
        var FileName = baseResponse.data['fileName'];

        const blob = b64toBlob(Bytes, ContentType);
        saveAs(blob, FileName);
      }
    });
  }
  splitDescription(description: string): string[] {
    return description.split('OR');
  }
  splitDescriptionDetail(description: string): string[] {
    const parts = description ? description.split('\\n').map(part => part.trim()).filter(part => part) : [];
    return parts;
  }
  getDashboardData() {

    this.portalService.getDashboardData()
      .subscribe(baseResponse => {
        if (baseResponse != null) {
          if (baseResponse.success != null) {
            if (baseResponse.success) {
              this.dashboardDataModel = baseResponse.data;
              // console.log( baseResponse.data);
              this.startCountingAnimation(); // Start animation only after data is loaded

            }
          }

        }

      })
  }


  getTenderData() {

    this.payRequestModel.Type = listType.TendersCountPortal;
    this.payRequestModel.ID = 0;
    this.payRequestModel.pagination = this.paginationModel;
    this.payRequestModel.pagination.pageSize = "10"
    this.portalService.GetPayDetailListTenderEIOPQ(this.payRequestModel)
      .subscribe(baseResponse => {
        if (baseResponse != null) {
          if (baseResponse.success != null) {
            if (baseResponse.success) {
              let data = (baseResponse.data as any);
              this.tenderCount = data?.records;
            }
          }
        }
      })
  }

  startCountingAnimation() {
    const keys = [
      'ePADSPlansCounts',
      'ePADSTendersCounts',
      'totalEOICount',
      'totalPQCount',
      'ePADSEvalutaionsCounts',
      'ePADSContractsCounts'
    ];

    keys.forEach(key => {
      const endValue = this.dashboardDataModel?.[key] || 0;
      this.animatedCounts[key] = 0; // Initialize animation

      if (endValue > 0) {
        const duration = 8000; // Total animation duration (ms)
        const steps = Math.min(100, Math.max(10, Math.floor(endValue / 5))); // Adjust steps dynamically
        const intervalTime = duration / steps; // Calculate dynamic interval

        interval(intervalTime)
          .pipe(
            take(steps), // Ensure it stops after reaching the final value
            map(step => Math.round((step / steps) * endValue))
          )
          .subscribe(value => {
            this.animatedCounts[key] = value;
          });
      }
    });
  }

  openEpadtenders() {
    this.route.
      navigate
      ([
        '/tenders/Epadtenders'
      ], {
        queryParams: { EOI: true }
      });
  }
  PQ() {
    this.route.
      navigate
      ([
        '/tenders/Epadtenders'
      ], {
        queryParams: { PQ: true }
      });
  }

}
